export default __webpack_public_path__ + "static/media/img-0386-switzerland-half-face.68d63413.png";